// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"b490aea5","352":"840f001e","437":"b89a3af1","629":"53f7f190","850":"3d9db72b"}[chunkId] + ".chunk.css";
};